var plugin_rtlignore_default = {
  "alignLeft": "w3w3p",
  "textWrapNowrap": "XDLog",
  "alignRight": "UVySJ",
  "alignCenter": "rDaES",
  "sizeFullWidth": "_7-tQ7",
  "renderedInTable": "c-sjJ",
  "sizeOriginal": "YAA8a",
  "sizeContent": "-nBvh",
  "sizeSmall": "qP60n",
  "sizeSmallCenter": "uKPNM",
  "flex": "W-qO6",
  "atomic": "C-UfD",
  "embed": "_7EZS2",
  "horizontalScrollbar": "QOWoS",
  "pluginContainerMobile": "_0MVRk"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
